"use client";

import { useEffect, useRef } from "react";
import Link from "next/link";

export default function CTASection() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add("revealed"); });
      },
      { threshold: 0.15 }
    );
    const els = ref?.current?.querySelectorAll(".reveal-hidden");
    els?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section ref={ref} className="section-padding bg-sand">
      <div className="max-w-5xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="relative overflow-hidden rounded-4xl bg-gradient-navy p-10 sm:p-14 text-center reveal-hidden">
          {/* Background decoration */}
          <div className="absolute top-0 right-0 w-64 h-64 rounded-full bg-gold/10 blur-3xl pointer-events-none" />
          <div className="absolute bottom-0 left-0 w-64 h-64 rounded-full bg-blue-400/5 blur-3xl pointer-events-none" />
          <div className="absolute inset-0 opacity-5" style={{
            backgroundImage: `radial-gradient(circle at 50% 50%, rgba(201,168,76,0.4) 0%, transparent 50%)`
          }} />

          <div className="relative z-10">
            <span className="inline-block text-gold text-xs font-bold uppercase tracking-widest mb-4">
              Start Today
            </span>
            <h2 className="font-heading text-4xl sm:text-5xl text-white mb-5 leading-tight">
              Your Property Deserves{" "}
              <span className="text-gold italic font-light">Premier</span> Care
            </h2>
            <p className="text-white/60 text-lg max-w-xl mx-auto mb-10">
              Free consultation. No contracts. Cancel anytime.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                href="/contact"
                className="btn-gold px-10 py-4 rounded-full font-semibold text-base flex items-center gap-2.5 group"
              >
                Get a Free Quote
                <svg className="w-4 h-4 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </Link>
              <Link
                href="/services"
                className="btn-ghost px-10 py-4 rounded-full font-medium text-base"
              >
                View Services
              </Link>
            </div>

            <p className="text-white/30 text-xs mt-6">
              Typical response within 2 hours · (855) 596-3948
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}